export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DoubleColumns.vue?vue&type=template&id=46f80536&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/BudgetReport/DoubleColumns.vue?vue&type=template&id=46f80536&scoped=true
// module id = 2199
// module chunks = 31